import { useSelector } from "react-redux";
import {
  Grid,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";

import PageviewsSection from "./sections/PageviewsSection";
import OutboundClicksSection from "./sections/OutboundClicksSection";
import CtaClicksSection from "./sections/CtaClicksSection";
import CtaClickListSection from "./sections/CtaClickListSection";
import VideoMetricsSection from "./sections/VideoMetricsSection";
import StoryLinksSection from "./sections/StoryLinksSection";
import TeaserABSection from "./sections/TeaserABSection";
import StoryABSection from "./sections/StoryABSection";
import KPIMetricsSection from "./sections/KPIMetricsSection.jsx";
import StoryInfoSection from "./sections/StoryInfoSection.jsx";
import StoryMetadataSection from "./sections/StoryMetadataSection.jsx";
import { Expand } from "@mui/icons-material";
import { ExpandableSection } from "./ExpandableSection.jsx";

const trimStoryID = (storyID) => storyID.replace(/-\w{2}/, "");

const Story = ({ story, classes, index }) => {
  const { metadata, isDailyDeal, storyKPIs } = story;

  return (
    <ExpandableSection
      title={`ID ${trimStoryID(story.id)}: ${story.name}`}
      classes={classes}
      expanded={index === 0}
    >
      <Grid container rowSpacing={2}>
        <StoryMetadataSection
          metadata={metadata}
          languages={story.languages}
          classes={classes}
        />

        <StoryInfoSection
          format={story.format}
          optimization_target={story.optimization_target}
          creator={story.creator}
          classes={classes}
        />

        <KPIMetricsSection
          storyKPIs={storyKPIs}
          gaSummarized={story.gaSummarized}
        />

        {(Array.isArray(story.media_titles) || story.reportType === "URL") &&
          !story.isLinkoutCampaign &&
          !isDailyDeal && (
            <StoryLinksSection items={story.links} classes={classes} />
          )}

        <PageviewsSection items={storyKPIs.byMediaTitle} classes={classes} />

        <OutboundClicksSection
          items={storyKPIs.outboundClicksPerURL}
          classes={classes}
        />

        <CtaClicksSection
          items={storyKPIs.ctaClicksPerElementName}
          classes={classes}
        />

        <VideoMetricsSection
          items={Object.values(story.gaSummarized?.videoMetricsByTitle ?? {})}
          classes={classes}
        />

        <CtaClickListSection items={storyKPIs.ctaClickList} classes={classes} />

        {story.reportType !== "URL" && (
          <TeaserABSection items={story.creativesWithDFP} classes={classes} />
        )}

        <StoryABSection item={story.abTest} classes={classes} />
      </Grid>
    </ExpandableSection>
  );
};

export default Story;
